export default __webpack_public_path__ + "static/media/caffe.c66ad145.png";